<!-- 搜索功能页 -->
<template>
  <div class="page-content">
    <c-header pageName="移位"></c-header>
    <div class="search-content flex-wrap">
      <div class="content-item flex">
        <section class="search-tool">
          <van-field v-model="slCode" autofocus clearable/>
          <span @click="onSearch">扫描新库位</span>
        </section>
      </div>
    </div>
    <div class="search-result" >
      <div class="storageLocation flex-wrap">
        <div class="order flex-wrap" v-show="stockInfo && stockInfo.id">
          <div
            class="order-item flex-wrap">
            <section>商家 : {{ stockInfo.shipper.name }}</section>
            <section>商品名称 : {{ stockInfo.productName }}</section>
            <section>国际条码 : {{ stockInfo.barCode }}</section>
            <section>库存 : {{ stockInfo.stockDataOne.qty }}</section>
            <section>批次 : {{ stockInfo.batSn }}</section>
            <section>规格 : {{ stockInfo.specVal }}</section>
            <section>效期 : {{ stockInfo.productDate|dateSub }} ~ {{ stockInfo.invalidDate|dateSub }}</section>
            <section>板号 : {{ stockInfo.bandSn }}</section>
            <section>商品状态 :&nbsp;
              <span :style="stockInfo.defectFlag ? 'color: #F56C6C' : 'color: #67C23A'">
              {{ stockInfo.defectFlag ? "不良品" : "良品" }}
            </span>
            </section>
            <section>库存状态 :&nbsp;
              <div v-for="status in StockStatus()" :key="status.value">
                <span v-if="status.value === stockInfo.stockStatus" :style="`color: ${status.color}`"> {{status.label }}</span>
              </div>
            </section>
            <section>库区 : {{ stockInfo.szCode }}</section>
            <section>库位 : {{ stockInfo.slCode }}</section>
          </div>
        </div>
        <div class="header flex-wrap mt-5" v-show="showResult">
          <section>库区 : {{ storageLocation.storageZone.szCode }}</section>
          <section>库位 : {{ storageLocation.slCode }}</section>
        </div>
      </div>
      <div class="tools" @click="handleMove"  v-show="showResult">
        <section>确定移位</section>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import {StockStatus} from "../common/constant";

export default {
  data() {
    return {
      slCode: "", // 库位
      barCode: "", //条形码
      ownWarehouseList: [], // 用户绑定的仓库
      selectWarehouse: {}, // 选中的仓库
      warehousePicker: [],
      showWarehousePicker: false,
      showResult: false, // 显示搜索结果
      warehouseId: "",
      storageLocation: {
        storageZone: {
          szCode: ""
        },
      },
      stockInfo: {
        shipper: {
          name: '',
        },
      }
    };
  },
  components: {
    "c-header": Header
  },
  mounted() {
    this.id = this.$route.query.id;
    this.warehouseId = this.$route.query.wid;
    this.getStockDetail(this.id)
  },
  methods: {
    StockStatus() {
      return StockStatus
    },
    handleMove() {
      this.$post(this.URL.move, {
        id: this.stockInfo.id,
        strValue: this.storageLocation.slCode
      }).then(res => {
        if (res.success) {
          this.$toast.success("移位成功");
          this.showResult = false;
          this.searchKey = "";
          this.storageLocation = {
            storageZone: {
              szCode: ""
            },
            slCode: "",
          }
          this.stockInfo = {
            shipper: {
              name: '',
            },
          }
          this.$router.push({ path: "/stockMove" });
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    getStockDetail(id) {
      let requestUrl = this.URL.findStockDetail;
      this.$post(requestUrl, {id}).then(res => {
        if (res.success) {
          this.stockInfo = res.data;
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 搜索
    onSearch() {
      let requestUrl = this.URL.findBySlCode;
      let param = {
        id: this.warehouseId
      };
      param.strValue = this.slCode;
      this.$post(requestUrl, param).then(res => {
        if (res.success) {
          this.showResult = true;
          this.storageLocation = res.data;
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.nav-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  background-color: #dc6350;
  padding: 0 3rem;
  align-items: center;
  justify-content: center;

  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }

  .activity {
    background-color: white;
    color: #dc6350;
  }

  section:first-child {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
  }

  section:last-child {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
  }
}

.search-content {
  padding: 1rem;
  font-size: 0.9rem;
  color: #444;

  .content-item {
    height: 2.5rem;
    align-items: center;
    border: 1px solid #f0f0f0;
    border-radius: 0.5rem;
  }

  .content-item:first-child {
    margin: 1rem 0 0 0;
    padding-left: 1rem;
  }

  .search-tool {
    display: flex;
    width: 100%;
    height: 2.5rem;
    align-items: center;
    border-radius: 0.5rem;
    padding-left: 1rem;
    margin: 0.3rem 0;

    .van-cell {
      display: inline-flex;
      align-items: center;
      height: 2.2rem;
      padding: 0;
    }

    .van-cell:not(:last-child)::after {
      border-bottom: none;
    }

    span {
      display: inline-flex;
      height: 2.5rem;
      align-items: center;
      justify-content: center;
      width: 8rem;
      border-left: 1px solid #f0f0f0;
    }
  }
}

.search-result {
  padding: 0 1rem 1rem 1rem;
  font-size: 0.85rem;
  color: #444;

  section {
    display: flex;
    width: 100%;
    height: 1.8rem;
    align-items: center;
    padding: 0 0.5rem;
  }

  .header {
    border: 1px solid #dc6350;
    border-radius: 0.5rem;
  }

  .order-item {
    font-size: 0.8rem;
    border-bottom: 1px dashed #f0f0f0;
    padding:0 ;

    section {
      height: 1.5rem;
    }
  }

  .goods-item {
    border-bottom: 1px dashed #f0f0f0;
    font-size: 0.8rem;

    .right {
      display: inline-flex;
      width: 90%;
      flex-wrap: wrap;
    }

    .left {
      display: inline-flex;
      width: 10%;
      align-items: center;
      justify-content: center;

      i {
        font-size: 1.3rem;
        color: #dc6350;
      }
    }
  }
}

.tools {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 1rem;
  font-size: 0.9rem;

  section {
    display: inline-flex;
    width: 18rem;
    height: 2rem;
    align-items: center;
    justify-content: center;
    background-color: #dc6350;
    border-radius: 0.3rem;
    color: white;
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/StockMoveDetail.vue